<template>
    <el-input
        v-bind="$attrs"
        v-model="modelValue"
        @input="onInput"
        size="small"
        step="any"
        class="custom-number-field"
        :disabled="disabled"
    >
        <template #prepix><slot name="prepix"></slot></template>
        <template #suffix><slot name="suffix"></slot></template>
        <template #prepend><slot name="prepend"></slot></template>
        <template #append><slot name="append"></slot></template>
    </el-input>
</template>

<script>
const formatDecimal = require('format-decimal');

export default {
    props: {
        value: null,
        thousandSeperator: {
            default() {
                return '.';
            },
        },
        decimalSeparator: {
            default() {
                return ',';
            },
        },
        disabled: {
            default() {
                return false;
            },
        },
    },
    data() {
        return {
            modelValue: null,
        };
    },
    created() {
        this.modelValue = this.parse(this.value);
    },
    watch: {
        value(val) {
            this.modelValue = this.parse(val);
            this.modelValue = this.parse(this.construct(this.modelValue));
            // this.$emit('input', this.construct(this.modelValue));
        },
    },
    methods: {
        parse(value) {
            let parsed = null;

            if (value) {
                parsed = formatDecimal(parseFloat(value), {
                    decimal: this.decimalSeparator,
                    thousands: this.thousandSeperator,
                    precision: 2,
                });

                if (typeof value !== 'string') {
                    value = String(value);
                }

                if (parsed.split(',').length > 1) {
                    const [num, decimal] = parsed.split(',');
                    const [, numDecimal] = value.split('.');

                    if (decimal == '00') {
                        /* is user input includes decimalSep, keep it */
                        if (value.includes('.')) {
                            parsed = num + this.decimalSeparator + numDecimal;
                        } else {
                            parsed = num;
                        }
                    }

                    if (parseInt(decimal, 10) > 0 || (numDecimal && numDecimal != '')) {
                        parsed = num + this.decimalSeparator + numDecimal;
                    }
                }
            }

            return parsed;
        },
        construct(value) {
            let constructed = null;

            if (value) {
                constructed = value
                    .replace(/[^0-9\\.\\,]+/g, '')
                    .replace(/\./gi, '')
                    .replace(/,/gi, '.');
            }

            return constructed;
        },
        onInput() {
            this.modelValue = this.parse(this.construct(this.modelValue));
            this.$emit('input', this.construct(this.modelValue));
        },
    },
};
</script>
